<template>
  <Modal
    v-show="modelVisible"
    :header="true"
    class="modal-recaptcha"
    @close="$emit('close')"
  >
    <template #header>
      <div class="modal-recaptcha-header">
        <h5>Verifikasi</h5>
      </div>
    </template>
    <template #default>
      <div class="modal-recpatcha-body">
        <span class="recaptcha-title">Please check the box below to proceed</span>
        <div
          :id="id"
          class="recaptcha-wrapper"
          style="margin-top: 1rem;"
        />
      </div>
    </template>
  </Modal>
</template>
<script>
import Modal from "./Modal.vue";
export default {
  components: { Modal },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      widgetId: null
    }
  },
  computed: {
    modelVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    } 
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          document.documentElement.style.overflow = 'hidden';
        } else {
          document.documentElement.style.overflow = 'visible';
        }
      },
      immediate: true
    }
  },
  mounted() {
    document.documentElement.style.overflow = 'visible';
    this.setRecpatcha()
  },
  methods: {
    setRecpatcha() {
      this.widgetId = window.grecaptcha.render(`${this.id}`, {
        sitekey: this.siteKey,
        size: '100%',
        callback: this.onCallbackCaptcha,
        'expired-callback': this.onCallbackCaptchaExpired,
        'error-callback': this.onCallbackCaptchaError
      })

      this.$emit('widget-id', this.widgetId)
    },
    onCallbackCaptcha(res) {
      this.$emit('response', res)
    },
    onCallbackCaptchaExpired() {
      window.grecaptcha.reset(this.widgetId)
      this.$emit('expired')

    },
    onCallbackCaptchaError() {
      this.$emit('error')
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/style.scss';
.modal-recaptcha {
  color: $color-base-text;
  width: 100vw !important;
  height: 100vh !important;

  &-header {
    padding: 1.25rem 1.5rem;

    & h5 {
      font-size: 1.25rem;
      font-weight: 600;
      line-height: 1.5237rem;
      letter-spacing: -0.02em;
    }
  }

  &-body {
    width: 100%;

    & span {
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5rem;
      letter-spacing: -0.02em;
    };

  }

  & ::v-deep .modal-lp__content__body {
    padding: 1.25rem 1.5rem !important;
  }
}
</style>
